"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqData = [{
  question: "How does storytelling help my child process their experiences?",
  answer: "Storytelling provides a safe, imaginative container for children to externalize complex emotions. By creating narratives and characters, they can explore their world with a sense of agency, helping them transform overwhelming moments into stories of resilience and hope."
}, {
  question: "What should we expect during a weekend retreat or day program?",
  answer: "Our programs are designed to be gentle and restorative. Families engage in guided storytelling, soft movement, and creative arts in a peaceful environment. We focus on fostering deep connection and providing practical tools for emotional expression that you can take home."
}, {
  question: "Are the videos in the Story Library appropriate for all ages?",
  answer: "Yes, our therapeutic video series is carefully crafted to be trauma-informed and age-appropriate. These stories use calming visuals and gentle narratives to help children navigate medical procedures or life transitions with less anxiety and more understanding."
}, {
  question: "How can clinicians and specialists use these resources?",
  answer: "We offer specialized digital libraries and physical toolkits for Clinicians and Child Life Specialists. These resources serve as therapeutic bridges, helping professionals facilitate communication and provide comfort to children in clinical settings through the power of art and story."
}, {
  question: "Is my family's privacy protected when we share our stories?",
  answer: "Your trust is our priority. We operate with the highest standards of dignity and consent. No child's story or artwork is ever shared without the explicit, informed permission of their caregivers, ensuring The Story Haven remains a safe sanctuary for everyone."
}];
export default function Faq() {
  return <section data-section-id="17827" id="faq" className="bg-background text-foreground py-24">
      <div className="mx-auto max-w-3xl px-8">
        <div className="mb-12 text-center">
          <h2 className="text-primary mb-4 text-3xl font-serif font-bold md:text-5xl tracking-tight">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed">
            Find gentle answers and guidance as you explore our community of
            healing, creativity, and connection.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border border-b last:border-b-0 backdrop-blur-sm transition-all duration-300" data-index={i}>
              <AccordionTrigger className="text-primary hover:text-amber-500 hover:no-underline data-[state=open]:text-amber-600 py-6 text-left text-lg md:text-xl font-medium transition-colors [&[data-state=open]>svg]:text-amber-600">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}